<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <div class="main-custom-tabs">
      <template v-if="isLoading">
        <div class="loading"></div>
      </template>

      <b-tabs v-else v-model="tabIndex" card>
        <template v-for="(status, index) in statusList">
          <b-tab v-if="orders.filter((order) => order.status === status).length > 0" :key="index">
            <template #title>
              <span class="text-uppercase">{{ $t(`statusList.${status}`) }}</span>
            </template>

            <template>
              <data-list-item
                :orders="orders.filter((order) => order.status === status)"
                :status="status"
                @update="fetchOrders"
              />
              <b-row v-if="numberOfPages > 0">
                <b-colxx xxs="12">
                  <b-pagination-nav
                    size="sm"
                    :number-of-pages="numberOfPages"
                    :link-gen="linkGen"
                    v-model="page"
                    :per-page="perPage"
                    align="center"
                  >
                    <template v-slot:next-text>
                      <i class="simple-icon-arrow-right" />
                    </template>
                    <template v-slot:prev-text>
                      <i class="simple-icon-arrow-left" />
                    </template>
                    <template v-slot:first-text>
                      <i class="simple-icon-control-start" />
                    </template>
                    <template v-slot:last-text>
                      <i class="simple-icon-control-end" />
                    </template>
                  </b-pagination-nav>
                </b-colxx>
              </b-row>
            </template>
          </b-tab>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Orders/DataList.vue'
import { handleObjectInternalization, handleArrayDataInternalization } from '@/utils'

export default {
  components: {
    'data-list-item': DataListItem
  },
  data() {
    return {
      tabIndex: 0,
      statusList: ['waiting', 'approved', 'delivery', 'finish', 'cancel'],
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/orders/list'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    orders() {
      const orders = this.$store.getters['orders/orders']

      return orders.map((order) => ({
        ...order,
        payment: handleObjectInternalization(order.payment, ['name'], this.$i18n.locale),
        products: handleArrayDataInternalization(order.products, ['name', 'content'], this.$i18n.locale)
      }))
    },
    isLoading() {
      return this.$store.getters['orders/isLoading']
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchOrders() {
      this.$store.dispatch('orders/fetchOrders', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchOrders()
    }
  }
}
</script>
